const Galleryimg = [
    {
      id: 1,
      image: '/photos/media/1.jpg',
    },
    {
        id: 16,
        image: '/photos/media/16.jpg',
      },
      {
        id: 17,
        image: '/photos/media/17.jpg',
      },
      {
        id: 18,
        image: '/photos/media/18.jpg',
      },
      {
        id: 19,
        image: '/photos/media/19.jpg',
      },
      {
        id: 20,
        image: '/photos/media/20.jpg',
      },
    
    {
      id: 10,
      image: '/photos/media/10.jpg',
    },
    {
      id: 11,
      image: '/photos/media/11.jpg',
    },
    {
      id: 12,
      image: '/photos/media/12.jpg',
    },
    {
      id: 13,
      image: '/photos/media/13.jpg',
    },
    {
      id: 14,
      image: '/photos/media/14.jpg',
    },
    {
      id: 15,
      image: '/photos/media/15.jpg',
    },
    {
        id: 2,
        image: '/photos/media/2.jpg',
      },
      {
        id: 3,
        image: '/photos/media/3.jpg',
      },
      {
        id: 4,
        image: '/photos/media/4.jpg',
      },
      {
        id: 5,
        image: '/photos/media/5.jpg',
      },
      {
        id: 6,
        image: '/photos/media/6.jpg',
      },
      {
        id: 7,
        image: '/photos/media/7.jpg',
      },
      {
        id: 8,
        image: '/photos/media/8.jpg',
      },
      {
        id: 9,
        image: '/photos/media/9.jpg',
      },
   
  ];
  
  export default Galleryimg;
  